// src/components/Testimonials.js
import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  SimpleGrid,
  Icon,
  Avatar,
} from '@chakra-ui/react';
import { FaStar, FaQuoteRight } from 'react-icons/fa';

// Reusable Testimonial Card Component
const TestimonialCard = ({ name, role, image, rating, title, children }) => {
  return (
    <VStack
      bg="blue.900" // A slightly darker shade than the section background
      p={8}
      spacing={6}
      borderRadius="lg"
      align="flex-start"
      position="relative"
      overflow="hidden"
      textAlign={{ base: 'center', md: 'left' }}
    >
      <Icon
        as={FaQuoteRight}
        position="absolute"
        top={6}
        right={6}
        boxSize={12}
        color="white"
        opacity="0.1"
      />
      <HStack spacing={1} alignSelf={{ base: 'center', md: 'flex-start' }}>
        {Array(5)
          .fill('')
          .map((_, i) => (
            <Icon key={i} as={FaStar} color={i < rating ? 'orange.400' : 'gray.500'} />
          ))}
      </HStack>
      <Heading as="h3" size="md">{title}</Heading>
      <Text color="gray.300" fontStyle="italic">
        "{children}"
      </Text>
      <HStack alignSelf={{ base: 'center', md: 'flex-start' }} pt={4}>
        <Avatar size="md" name={name} src={image} />
        <VStack align="flex-start" spacing={0}>
          <Text fontWeight="bold">{name}</Text>
          <Text fontSize="sm" color="gray.400">{role}</Text>
        </VStack>
      </HStack>
    </VStack>
  );
};

export default function Testimonials() {
  const testimonialsData = [
    {
      name: 'Yonas Tesfaye',
      role: 'Happy Client',
      image: 'https://via.placeholder.com/100x100.png?text=Leslie',
      rating: 5,
      title: 'Beyond Expectations!',
      text: "Their team was more than just a contractor; they were a partner in revitalizing our city's core. They delivered a beautiful public space that was on-time, on-budget, and has become a beloved gathering place for our residents. Their commitment to local hiring was also exemplary.",
    },
    {
      name: 'Abebe Tefri',
      role: 'Happy Client',
      image: 'https://via.placeholder.com/100x100.png?text=Jenny',
      rating: 5,
      title: 'Top-Notch Service!',
      text: 'Managing the complexities of the new riverfront bridge required a partner with unparalleled skill and integrity. Their team not only met but exceeded every engineering challenge, delivering a critical piece of infrastructure that will serve our citizens safely for decades to come.',
    },
  ];

  return (
    <Box as="section" bg="blue.800" color="white" py={{ base: 16, md: 24 }}>
      <VStack maxW="7xl" mx="auto" px={8} spacing={12}>
        {/* Section Header */}
        <VStack spacing={4} textAlign="center">
          <Text color="orange.400" fontWeight="bold">Testimonials</Text>
          <Heading as="h2" size="2xl" fontWeight="bold">
            Experience Shared by Our Clients
          </Heading>
        </VStack>

        {/* Testimonials Grid */}
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} w="full">
          {testimonialsData.map((testimonial) => (
            <TestimonialCard key={testimonial.name} {...testimonial}>
              {testimonial.text}
            </TestimonialCard>
          ))}
        </SimpleGrid>

        {/* Pagination Dots */}
        <HStack spacing={2}>
          <Box w={8} h={2} bg="orange.400" borderRadius="full" />
          <Box w={2} h={2} bg="gray.500" borderRadius="full" />
          <Box w={2} h={2} bg="gray.500" borderRadius="full" />
          <Box w={2} h={2} bg="gray.500" borderRadius="full" />
        </HStack>
      </VStack>
    </Box>
  );
}